const currency = [
  {
    key: 'AED',
    value: 'Dirham de EAU',
    decimals: 2,
  },
  {
    key: 'AFN',
    value: 'Afghani',
    decimals: 2,
  },
  {
    key: 'ALL',
    value: 'Lek',
    decimals: 2,
  },
  {
    key: 'AMD',
    value: 'Dram armenio',
    decimals: 2,
  },
  {
    key: 'ANG',
    value: 'Florín antillano neerlandés',
    decimals: 2,
  },
  {
    key: 'AOA',
    value: 'Kwanza',
    decimals: 2,
  },
  {
    key: 'ARS',
    value: 'Peso Argentino',
    decimals: 2,
  },
  {
    key: 'AUD',
    value: 'Dólar Australiano',
    decimals: 2,
  },
  {
    key: 'AWG',
    value: 'Aruba Florin',
    decimals: 2,
  },
  {
    key: 'AZN',
    value: 'Azerbaijanian Manat',
    decimals: 2,
  },
  {
    key: 'BAM',
    value: 'Convertibles marca',
    decimals: 2,
  },
  {
    key: 'BBD',
    value: 'Dólar de Barbados',
    decimals: 2,
  },
  {
    key: 'BDT',
    value: 'Taka',
    decimals: 2,
  },
  {
    key: 'BGN',
    value: 'Lev búlgaro',
    decimals: 2,
  },
  {
    key: 'BHD',
    value: 'Dinar de Bahrein',
    decimals: 3,
  },
  {
    key: 'BIF',
    value: 'Burundi Franc',
    decimals: 0,
  },
  {
    key: 'BMD',
    value: 'Dólar de Bermudas',
    decimals: 2,
  },
  {
    key: 'BND',
    value: 'Dólar de Brunei',
    decimals: 2,
  },
  {
    key: 'BOB',
    value: 'Boliviano',
    decimals: 2,
  },
  {
    key: 'BOV',
    value: 'Mvdol',
    decimals: 2,
  },
  {
    key: 'BRL',
    value: 'Real brasileño',
    decimals: 2,
  },
  {
    key: 'BSD',
    value: 'Dólar de las Bahamas',
    decimals: 2,
  },
  {
    key: 'BTN',
    value: 'Ngultrum',
    decimals: 2,
  },
  {
    key: 'BWP',
    value: 'Pula',
    decimals: 2,
  },
  {
    key: 'BYR',
    value: 'Rublo bielorruso',
    decimals: 0,
  },
  {
    key: 'BZD',
    value: 'Dólar de Belice',
    decimals: 2,
  },
  {
    key: 'CAD',
    value: 'Dolar Canadiense',
    decimals: 2,
  },
  {
    key: 'CDF',
    value: 'Franco congoleño',
    decimals: 2,
  },
  {
    key: 'CHE',
    value: 'WIR Euro',
    decimals: 2,
  },
  {
    key: 'CHF',
    value: 'Franco Suizo',
    decimals: 2,
  },
  {
    key: 'CHW',
    value: 'Franc WIR',
    decimals: 2,
  },
  {
    key: 'CLF',
    value: 'Unidad de Fomento',
    decimals: 4,
  },
  {
    key: 'CLP',
    value: 'Peso chileno',
    decimals: 0,
  },
  {
    key: 'CNY',
    value: 'Yuan Renminbi',
    decimals: 2,
  },
  {
    key: 'COP',
    value: 'Peso Colombiano',
    decimals: 2,
  },
  {
    key: 'COU',
    value: 'Unidad de Valor real',
    decimals: 2,
  },
  {
    key: 'CRC',
    value: 'Colón costarricense',
    decimals: 2,
  },
  {
    key: 'CUC',
    value: 'Peso Convertible',
    decimals: 2,
  },
  {
    key: 'CUP',
    value: 'Peso Cubano',
    decimals: 2,
  },
  {
    key: 'CVE',
    value: 'Cabo Verde Escudo',
    decimals: 2,
  },
  {
    key: 'CZK',
    value: 'Corona checa',
    decimals: 2,
  },
  {
    key: 'DJF',
    value: 'Franco de Djibouti',
    decimals: 0,
  },
  {
    key: 'DKK',
    value: 'Corona danesa',
    decimals: 2,
  },
  {
    key: 'DOP',
    value: 'Peso Dominicano',
    decimals: 2,
  },
  {
    key: 'DZD',
    value: 'Dinar argelino',
    decimals: 2,
  },
  {
    key: 'EGP',
    value: 'Libra egipcia',
    decimals: 2,
  },
  {
    key: 'ERN',
    value: 'Nakfa',
    decimals: 2,
  },
  {
    key: 'ETB',
    value: 'Birr etíope',
    decimals: 2,
  },
  {
    key: 'EUR',
    value: 'Euro',
    decimals: 2,
  },
  {
    key: 'FJD',
    value: 'Dólar de Fiji',
    decimals: 2,
  },
  {
    key: 'FKP',
    value: 'Libra malvinense',
    decimals: 2,
  },
  {
    key: 'GBP',
    value: 'Libra Esterlina',
    decimals: 2,
  },
  {
    key: 'GEL',
    value: 'Lari',
    decimals: 2,
  },
  {
    key: 'GHS',
    value: 'Cedi de Ghana',
    decimals: 2,
  },
  {
    key: 'GIP',
    value: 'Libra de Gibraltar',
    decimals: 2,
  },
  {
    key: 'GMD',
    value: 'Dalasi',
    decimals: 2,
  },
  {
    key: 'GNF',
    value: 'Franco guineano',
    decimals: 0,
  },
  {
    key: 'GTQ',
    value: 'Quetzal',
    decimals: 2,
  },
  {
    key: 'GYD',
    value: 'Dólar guyanés',
    decimals: 2,
  },
  {
    key: 'HKD',
    value: 'Dolar De Hong Kong',
    decimals: 2,
  },
  {
    key: 'HNL',
    value: 'Lempira',
    decimals: 2,
  },
  {
    key: 'HRK',
    value: 'Kuna',
    decimals: 2,
  },
  {
    key: 'HTG',
    value: 'Gourde',
    decimals: 2,
  },
  {
    key: 'HUF',
    value: 'Florín',
    decimals: 2,
  },
  {
    key: 'IDR',
    value: 'Rupia',
    decimals: 2,
  },
  {
    key: 'ILS',
    value: 'Nuevo Shekel Israelí',
    decimals: 2,
  },
  {
    key: 'INR',
    value: 'Rupia india',
    decimals: 2,
  },
  {
    key: 'IQD',
    value: 'Dinar iraquí',
    decimals: 3,
  },
  {
    key: 'IRR',
    value: 'Rial iraní',
    decimals: 2,
  },
  {
    key: 'ISK',
    value: 'Corona islandesa',
    decimals: 0,
  },
  {
    key: 'JMD',
    value: 'Dólar Jamaiquino',
    decimals: 2,
  },
  {
    key: 'JOD',
    value: 'Dinar jordano',
    decimals: 3,
  },
  {
    key: 'JPY',
    value: 'Yen',
    decimals: 0,
  },
  {
    key: 'KES',
    value: 'Chelín keniano',
    decimals: 2,
  },
  {
    key: 'KGS',
    value: 'Som',
    decimals: 2,
  },
  {
    key: 'KHR',
    value: 'Riel',
    decimals: 2,
  },
  {
    key: 'KMF',
    value: 'Franco Comoro',
    decimals: 0,
  },
  {
    key: 'KPW',
    value: 'Corea del Norte ganó',
    decimals: 2,
  },
  {
    key: 'KRW',
    value: 'Won',
    decimals: 0,
  },
  {
    key: 'KWD',
    value: 'Dinar kuwaití',
    decimals: 3,
  },
  {
    key: 'KYD',
    value: 'Dólar de las Islas Caimán',
    decimals: 2,
  },
  {
    key: 'KZT',
    value: 'Tenge',
    decimals: 2,
  },
  {
    key: 'LAK',
    value: 'Kip',
    decimals: 2,
  },
  {
    key: 'LBP',
    value: 'Libra libanesa',
    decimals: 2,
  },
  {
    key: 'LKR',
    value: 'Rupia de Sri Lanka',
    decimals: 2,
  },
  {
    key: 'LRD',
    value: 'Dólar liberiano',
    decimals: 2,
  },
  {
    key: 'LSL',
    value: 'Loti',
    decimals: 2,
  },
  {
    key: 'LYD',
    value: 'Dinar libio',
    decimals: 3,
  },
  {
    key: 'MAD',
    value: 'Dirham marroquí',
    decimals: 2,
  },
  {
    key: 'MDL',
    value: 'Leu moldavo',
    decimals: 2,
  },
  {
    key: 'MGA',
    value: 'Ariary malgache',
    decimals: 2,
  },
  {
    key: 'MKD',
    value: 'Denar',
    decimals: 2,
  },
  {
    key: 'MMK',
    value: 'Kyat',
    decimals: 2,
  },
  {
    key: 'MNT',
    value: 'Tugrik',
    decimals: 2,
  },
  {
    key: 'MOP',
    value: 'Pataca',
    decimals: 2,
  },
  {
    key: 'MRO',
    value: 'Ouguiya',
    decimals: 2,
  },
  {
    key: 'MUR',
    value: 'Rupia de Mauricio',
    decimals: 2,
  },
  {
    key: 'MVR',
    value: 'Rupia',
    decimals: 2,
  },
  {
    key: 'MWK',
    value: 'Kwacha',
    decimals: 2,
  },
  {
    key: 'MXN',
    value: 'Peso Mexicano',
    decimals: 2,
  },
  {
    key: 'MXV',
    value: 'México Unidad de Inversión (UDI)',
    decimals: 2,
  },
  {
    key: 'MYR',
    value: 'Ringgit malayo',
    decimals: 2,
  },
  {
    key: 'MZN',
    value: 'Mozambique Metical',
    decimals: 2,
  },
  {
    key: 'NAD',
    value: 'Dólar de Namibia',
    decimals: 2,
  },
  {
    key: 'NGN',
    value: 'Naira',
    decimals: 2,
  },
  {
    key: 'NIO',
    value: 'Córdoba Oro',
    decimals: 2,
  },
  {
    key: 'NOK',
    value: 'Corona noruega',
    decimals: 2,
  },
  {
    key: 'NPR',
    value: 'Rupia nepalí',
    decimals: 2,
  },
  {
    key: 'NZD',
    value: 'Dólar de Nueva Zelanda',
    decimals: 2,
  },
  {
    key: 'OMR',
    value: 'Rial omaní',
    decimals: 3,
  },
  {
    key: 'PAB',
    value: 'Balboa',
    decimals: 2,
  },
  {
    key: 'PEN',
    value: 'Nuevo Sol',
    decimals: 2,
  },
  {
    key: 'PGK',
    value: 'Kina',
    decimals: 2,
  },
  {
    key: 'PHP',
    value: 'Peso filipino',
    decimals: 2,
  },
  {
    key: 'PKR',
    value: 'Rupia de Pakistán',
    decimals: 2,
  },
  {
    key: 'PLN',
    value: 'Zloty',
    decimals: 2,
  },
  {
    key: 'PYG',
    value: 'Guaraní',
    decimals: 0,
  },
  {
    key: 'QAR',
    value: 'Qatar Rial',
    decimals: 2,
  },
  {
    key: 'RON',
    value: 'Leu rumano',
    decimals: 2,
  },
  {
    key: 'RSD',
    value: 'Dinar serbio',
    decimals: 2,
  },
  {
    key: 'RUB',
    value: 'Rublo ruso',
    decimals: 2,
  },
  {
    key: 'RWF',
    value: 'Franco ruandés',
    decimals: 0,
  },
  {
    key: 'SAR',
    value: 'Riyal saudí',
    decimals: 2,
  },
  {
    key: 'SBD',
    value: 'Dólar de las Islas Salomón',
    decimals: 2,
  },
  {
    key: 'SCR',
    value: 'Rupia de Seychelles',
    decimals: 2,
  },
  {
    key: 'SDG',
    value: 'Libra sudanesa',
    decimals: 2,
  },
  {
    key: 'SEK',
    value: 'Corona sueca',
    decimals: 2,
  },
  {
    key: 'SGD',
    value: 'Dolar De Singapur',
    decimals: 2,
  },
  {
    key: 'SHP',
    value: 'Libra de Santa Helena',
    decimals: 2,
  },
  {
    key: 'SLL',
    value: 'Leona',
    decimals: 2,
  },
  {
    key: 'SOS',
    value: 'Chelín somalí',
    decimals: 2,
  },
  {
    key: 'SRD',
    value: 'Dólar de Suriname',
    decimals: 2,
  },
  {
    key: 'SSP',
    value: 'Libra sudanesa Sur',
    decimals: 2,
  },
  {
    key: 'STD',
    value: 'Dobra',
    decimals: 2,
  },
  {
    key: 'SVC',
    value: 'Colon El Salvador',
    decimals: 2,
  },
  {
    key: 'SYP',
    value: 'Libra Siria',
    decimals: 2,
  },
  {
    key: 'SZL',
    value: 'Lilangeni',
    decimals: 2,
  },
  {
    key: 'THB',
    value: 'Baht',
    decimals: 2,
  },
  {
    key: 'TJS',
    value: 'Somoni',
    decimals: 2,
  },
  {
    key: 'TMT',
    value: 'Turkmenistán nuevo manat',
    decimals: 2,
  },
  {
    key: 'TND',
    value: 'Dinar tunecino',
    decimals: 3,
  },
  {
    key: 'TOP',
    value: 'Pa\'anga',
    decimals: 2,
  },
  {
    key: 'TRY',
    value: 'Lira turca',
    decimals: 2,
  },
  {
    key: 'TTD',
    value: 'Dólar de Trinidad y Tobago',
    decimals: 2,
  },
  {
    key: 'TWD',
    value: 'Nuevo dólar de Taiwán',
    decimals: 2,
  },
  {
    key: 'TZS',
    value: 'Shilling tanzano',
    decimals: 2,
  },
  {
    key: 'UAH',
    value: 'Hryvnia',
    decimals: 2,
  },
  {
    key: 'UGX',
    value: 'Shilling de Uganda',
    decimals: 0,
  },
  {
    key: 'USD',
    value: 'Dolar americano',
    decimals: 2,
  },
  {
    key: 'USN',
    value: 'Dólar estadounidense (día siguiente)',
    decimals: 2,
  },
  {
    key: 'UYI',
    value: 'Peso Uruguay en Unidades Indexadas (URUIURUI)',
    decimals: 0,
  },
  {
    key: 'UYU',
    value: 'Peso Uruguayo',
    decimals: 2,
  },
  {
    key: 'UZS',
    value: 'Uzbekistán Sum',
    decimals: 2,
  },
  {
    key: 'VEF',
    value: 'Bolívar',
    decimals: 2,
  },
  {
    key: 'VND',
    value: 'Dong',
    decimals: 0,
  },
  {
    key: 'VUV',
    value: 'Vatu',
    decimals: 0,
  },
  {
    key: 'WST',
    value: 'Tala',
    decimals: 2,
  },
  {
    key: 'XAF',
    value: 'Franco CFA BEAC',
    decimals: 0,
  },
  {
    key: 'XAG',
    value: 'Plata',
    decimals: 0,
  },
  {
    key: 'XAU',
    value: 'Oro',
    decimals: 0,
  },
  {
    key: 'XBA',
    value: 'Unidad de Mercados de Bonos Unidad Europea Composite (EURCO)',
    decimals: 0,
  },
  {
    key: 'XBB',
    value: 'Unidad Monetaria de Bonos de Mercados Unidad Europea (UEM-6)',
    decimals: 0,
  },
  {
    key: 'XBC',
    value: 'Mercados de Bonos Unidad Europea unidad de cuenta a 9 (UCE-9)',
    decimals: 0,
  },
  {
    key: 'XBD',
    value: 'Mercados de Bonos Unidad Europea unidad de cuenta a 17 (UCE-17)',
    decimals: 0,
  },
  {
    key: 'XCD',
    value: 'Dólar del Caribe Oriental',
    decimals: 2,
  },
  {
    key: 'XDR',
    value: 'DEG (Derechos Especiales de Giro)',
    decimals: 0,
  },
  {
    key: 'XOF',
    value: 'Franco CFA BCEAO',
    decimals: 0,
  },
  {
    key: 'XPD',
    value: 'Paladio',
    decimals: 0,
  },
  {
    key: 'XPF',
    value: 'Franco CFP',
    decimals: 0,
  },
  {
    key: 'XPT',
    value: 'Platino',
    decimals: 0,
  },
  {
    key: 'XSU',
    value: 'Sucre',
    decimals: 0,
  },
  {
    key: 'XTS',
    value: 'Códigos reservados específicamente para propósitos de prueba',
    decimals: 0,
  },
  {
    key: 'XUA',
    value: 'Unidad ADB de Cuenta',
    decimals: 0,
  },
  {
    key: 'XXX',
    value: 'Los códigos asignados para las transacciones en que intervenga ninguna moneda',
    decimals: 0,
  },
  {
    key: 'YER',
    value: 'Rial yemení',
    decimals: 2,
  },
  {
    key: 'ZAR',
    value: 'Rand',
    decimals: 2,
  },
  {
    key: 'ZMW',
    value: 'Kwacha zambiano',
    decimals: 2,
  },
  {
    key: 'ZWL',
    value: 'Zimbabwe Dólar',
    decimals: 2,
  },
];

module.exports = currency;
